import sideContainsComponent from './sideContainsComponent.vue'
export default sideContainsComponent
